import React, { useEffect, useState } from 'react';
import './App.css';
import meimage from './meimage.png'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav } from "react-bootstrap";
import { faCircleCheck, faPhoneSquare, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classnames from 'classnames';

function App(props) {
  const services = React.createRef();
  const company = React.createRef();
  const contact = React.createRef();
  const heroTitleRef = React.useRef(null);

  const [prevScrollpos, setPrevScrollpos] = useState(window.pageYOffset);
  const [visible, setVisible] = useState(true);
  const [lang, setLang] = useState('fi');

  const t = {
    fi: {
      nav_services: 'PALVELUT',
      nav_company: 'YRITYS',
      nav_contact: 'YHTEYSTIEDOT',
      services_heading: 'PALVELUT',
      services: [
        'Palvelen vaativissa ohjelmistokehityshankkeissa ja autan yrityksiä rakentamaan luotettavia ja skaalautuvia järjestelmiä. Minulla on erityisesti toimialakokemusta taloushallinnon järjestelmistä, kuten kirjanpito-, reskontra-, laskutus- ja ERP-järjestelmistä.',
        'Full Stack -sovelluskehitys on intohimoni. Olen keskittynyt erityisesti Microsoft-teknologioihin, joista minulla on yli 17 vuoden kokemus.',
        'Keskeisiä osaamisalueitani ovat .NET, ASP.NET Core, C#, SQL sekä vahva kokemus Azure-pilvipalveluista.',
      ],
      core_skills: 'Ydinosaaminen:',
      other_tools: 'Muut teknologiat ja työkalut:',
      ai_dev: 'AI-avusteinen kehitys:',
      company_heading: 'YRITYS',
      company: [
        'Teen töitä pääsääntöisesti tuntihinnoittelulla.',
        'Luotettavaa ja pitkäjänteistä tekemistä.',
        'Sitoudun asiakkaani tarpeisiin.',
      ],
      contact_heading: 'Ota yhteyttä',
      business_id: 'Y-tunnus',
    },
    en: {
      nav_services: 'SERVICES',
      nav_company: 'COMPANY',
      nav_contact: 'CONTACT',
      services_heading: 'SERVICES',
      services: [
        'I work on demanding software development projects and help companies build reliable and scalable systems. I have particularly strong domain experience in financial management systems, such as accounting, accounts receivable, billing, and ERP systems.',
        'Full Stack software development is my passion. I have focused especially on Microsoft technologies, with over 17 years of experience.',
        'My core areas of expertise include .NET, ASP.NET Core, C#, SQL, and extensive experience with Azure cloud services.',
      ],
      core_skills: 'Core Skills:',
      other_tools: 'Other technologies and tools:',
      ai_dev: 'AI-assisted development:',
      company_heading: 'COMPANY',
      company: [
        'I primarily work on an hourly billing model.',
        'Reliable and long-term commitment.',
        "I dedicate myself to my clients needs.",
      ],
      contact_heading: 'Get in touch',
      business_id: 'Business ID',
    },
  };
  const tr = t[lang];

  useEffect(() => {
    window.addEventListener("scroll", () => handleScroll())

    return () => {
      window.removeEventListener("scroll", () => handleScroll());
    }
  }, []);

  useEffect(() => {
    const el = heroTitleRef.current;
    if (!el) return;

    const finalText = 'AI POWERED SOFTWARE DEVELOPMENT';
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%&';
    let frame = 0;
    const totalFrames = 44;

    el.textContent = '';

    const delay = setTimeout(() => {
      el.style.opacity = '1';
      const timer = setInterval(() => {
        const progress = frame / totalFrames;
        el.textContent = finalText
          .split('')
          .map((char, i) => {
            if (char === ' ') return ' ';
            if (i < progress * finalText.length) return char;
            return chars[Math.floor(Math.random() * chars.length)];
          })
          .join('');
        frame++;
        if (frame > totalFrames) {
          el.textContent = finalText;
          clearInterval(timer);
          el.classList.add('hero-title--done');
        }
      }, 45);
    }, 350);

    return () => {
      clearTimeout(delay);
    };
  }, []);

  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    const visible = currentScrollPos < 200 || (prevScrollpos > currentScrollPos);

    setPrevScrollpos(currentScrollPos);
    setVisible(visible);
  };

  const executeScroll = (element) => {
    element.current.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <div className="app">
      <Navbar collapseOnSelect className={classnames("navbar-dark", { "navbar--hidden": !visible })} expand="md" fixed="top">
        <Navbar.Brand className="nav-brand" href="#services">
          BITVENTURE<br></br>
          <span className="nav-brand-sub nav-brand-accent">C# | .NET | Azure</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">
          </Nav>
          <Nav>
            <Nav.Link onClick={() => executeScroll(services)}>{tr.nav_services}</Nav.Link>
            <Nav.Link onClick={() => executeScroll(company)}>{tr.nav_company}</Nav.Link>
            <Nav.Link onClick={() => executeScroll(contact)}>{tr.nav_contact}</Nav.Link>
          </Nav>
          <div className="lang-switcher">
            <button className={`lang-btn${lang === 'fi' ? ' lang-btn--active' : ''}`} onClick={() => setLang('fi')}>FI</button>
            <span className="lang-divider">|</span>
            <button className={`lang-btn${lang === 'en' ? ' lang-btn--active' : ''}`} onClick={() => setLang('en')}>EN</button>
          </div>
        </Navbar.Collapse>
      </Navbar>
      <div className="app-background">
        <div className="hero-content">
          <h1 className="hero-title" ref={heroTitleRef}>AI POWERED SOFTWARE DEVELOPMENT</h1>
        </div>
      </div>
      <div className="container-fluid section-dark">
        <div ref={services} id="services">
          <div className="profile-strip">
            <img className="ownimg" src={meimage} alt="Ilkka Joentakanen" />
            <p className="profile-name">Ilkka Joentakanen</p>
            <p className="profile-title">Full Stack Developer</p>
          </div>
          <div className="services-full">
            <h2 className="font-300">{tr.services_heading}</h2>
            <div className="service-list">
              {tr.services.map((text, index) => (
                <div className="service-row" key={index}>
                  <FontAwesomeIcon className="fa-lg green" icon={faCircleCheck} />
                  <p>{text}</p>
                </div>
              ))}
            </div>
            <div className="skills-grid">
              <div>
                <p className="left mt-4 ai-tools-label">{tr.core_skills}</p>
                <div className="core-skills-section">
                  <div className="azure-feature-wrap">
                    <span className="azure-feature-badge">Azure</span>
                    <div className="azure-sub-row">
                      {["App Service", "Azure SQL", "Service Bus", "Application Insights", "Logic Apps", "+ More.."].map((item, i) => (
                        <span key={i} className="azure-sub-badge">{item}</span>
                      ))}
                    </div>
                  </div>
                  <div className="core-badges-row">
                    {[".NET", "C#", "SQL"].map((tech, i) => (
                      <span key={i} className="core-skill-badge">{tech}</span>
                    ))}
                  </div>
                </div>
              </div>
              <div>
                <p className="left ai-tools-label">{tr.ai_dev}</p>
                <div className="ai-tools-row">
                  <span className="ai-badge ai-badge--claude">
                    <span className="ai-badge__dot"></span>
                    Claude Code
                  </span>
                  <span className="ai-badge ai-badge--cursor">
                    <span className="ai-badge__dot"></span>
                    Cursor
                  </span>
                </div>
              </div>
              <div>
                <p className="left ai-tools-label">{tr.other_tools}</p>
                <div className="tech-badges-row">
                  {[
                    "React", "Angular", "JavaScript", "TypeScript", "CSS", "HTML",
                    "TeamCity", "Octopus CI/CD", "Azure DevOps", "Jira", "Confluence",
                    "WPF", "UWP", "Xamarin"
                  ].map((tech, index) => (
                    <span key={index} className="tech-badge">{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref={company} id="company" className="row">
          <div className="company-content col-md-12 col-sm-12">
            <h2 className="font-300">{tr.company_heading}</h2>
            {tr.company.map((text, index) => (
              <p key={index} className="company-text">{text}</p>
            ))}
          </div>
        </div>
        <div ref={contact} id="contact" className="contact-section">
          <div className="contact-container">
            <div className="contact-info">
              <h4>Bitventure Oy</h4>
              <p>Ahmalantie 10 B</p>
              <p>90150 Oulu</p>
              <p>{tr.business_id}: 3236265-5</p>
            </div>
            <div className="contact-details">
              <h4>{tr.contact_heading}</h4>
              <p>Ilkka Joentakanen</p>
              <p>
                <FontAwesomeIcon className="icon" icon={faPhoneSquare} />
                <a href="tel:0407609925">040 760 9925</a>
              </p>
              <p>
                <FontAwesomeIcon className="icon" icon={faEnvelope} />
                <a href="mailto:ilkka.joentakanen@bitventure.fi">ilkka.joentakanen@bitventure.fi</a>
              </p>
              <p>
                <FontAwesomeIcon className="icon" icon={faLinkedin} />
                <a href="https://www.linkedin.com/in/ilkka-joentakanen-abab6630/" target="_blank" rel="noreferrer">LinkedIn</a>
              </p>
            </div>
          </div>
        </div>
        <footer className="site-footer">
          © {new Date().getFullYear()} Bitventure Oy
        </footer>
      </div>
    </div>
  )
};

export default App;
